function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import ConfigBag from './ConfigBag';
import Bulma from './core';
/**
 * Base plugin class. Provides basic, common functionality.
 * @class Plugin
 * @since 0.7.0
 * @author  Thomas Erbe <vizuaalog@gmail.com>
 */

export default class Plugin {
  /**
   * Returns an object containing the default config for this plugin.
   * @returns {object} The default config object.
   */
  static defaultConfig() {
    return {};
  }
  /**
   * Create a plugin.
   * @param {object} config The config for this plugin
   */


  constructor() {
    let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let root = arguments.length > 1 ? arguments[1] : undefined;
    config.root = root instanceof Bulma ? root._elem : root;
    this.config = new ConfigBag(_objectSpread(_objectSpread({}, this.constructor.defaultConfig()), config));

    if (!root && !this.config.has('parent')) {
      throw new Error('A plugin requires a root and/or a parent.');
    }

    this.parent = this.config.get('parent', config.root ? config.root.parentNode : null);
    this._events = {};
  }

  on(event, callback) {
    if (!this._events.hasOwnProperty(event)) {
      this._events[event] = [];
    }

    this._events[event].push(callback);
  }

  trigger(event) {
    let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (!this._events.hasOwnProperty(event)) {
      return;
    }

    for (let i = 0; i < this._events[event].length; i++) {
      this._events[event][i](data);
    }
  }

  destroy() {
    Bulma(this.root).destroyData();
  }

}